import { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { createPortfolio } from "store/slices/portfolioSlice";
import { useAppDispatch, useAppSelector } from "store/store";

interface FormData {
  name?: string;
  portfolioId?: string;
  client?: number;
  partners?: number[];
  broker?: string;
  otherBrokerName?: string;
}

const useAddPortfolioModal = ({ setOpen }: any) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();

  const { loading: isSubmitting } = useAppSelector((state) => state.portfolio);

  const [isClientCreateModalOpen, setIsClientCreateModalOpen] = useState(false);

  const [portfolioReachLimit, setPortfolioReachLimit] = useState(false);

  const form = useForm<FormData>({
    defaultValues: {
      name: "",
      portfolioId: "",
      client: Number(id) || undefined,
      partners: [],
      broker: "",
      otherBrokerName: "",
    },
  });

  const onSubmit = (data: FormData) => {
    dispatch(createPortfolio(data))
      .unwrap()
      .then(() => setOpen(false))
      .catch((error) => {
        console.error("Error creating portfolio:", error);
        if (
          error ===
          "Portfolio creation failed: the advisor has reached the maximum allowed limit."
        ) {
          setPortfolioReachLimit(true);
        }
      });
  };

  return {
    isSubmitting,
    isClientCreateModalOpen,
    setIsClientCreateModalOpen,
    portfolioReachLimit,
    setPortfolioReachLimit,
    id,
    form,
    onSubmit,
  };
};

export default useAddPortfolioModal;
